import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import EditIcon from '@mui/icons-material/Edit';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import LockIcon from '@mui/icons-material/Lock';
import styles from "./adminmanageseller.module.css";
import { useCookies } from 'react-cookie';
import { disableSeller, enableSeller, getAllSellers } from '../../apis/admin';
import LoadingScreen from '../LoadingScreen';

export default function AdminManageSeller() {
  const { t } = useTranslation();
  const [editUserId, setEditUserId] = useState("");
  const [editedUser, setEditedUser] = useState("");
  const [cookies, setCookie] = useCookies(["access_token", "user_info"]);

  const [sellers, setSellers] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getAllSellers(cookies['access_token']).then((data) => {
      setSellers(data.data)
      setLoading(false)
    })
  }, [])

  const headers = [
    t('user_ID'),
    t('full_name'),
    t('gender'),
    t('email'),
    t('address'),
    t('city'),
    t('sign_up_date'),
    t('last_log_in'),
    t('actions')
  ];

  const handleEdit = (user) => {
    setEditUserId(user.id);
    setEditedUser({ ...user });
  };

  const handleLock = (id) => {
    console.log(`Lock account of user with ID: ${id}`);
    // Add logic to handle locking the user's account
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditedUser(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSave = () => {
    setSellers(prevData => prevData.map(user => user.id === editedUser.id ? editedUser : user));
    setEditUserId("");
    setEditedUser(null);
  };

  const handleDelete = () => {
    setSellers(prevData => prevData.filter(user => user.id !== editedUser.id));
    setEditUserId("");
    setEditedUser(null);
  };

  const handleCancel = () => {
    setEditUserId(null);
    setEditedUser(null);
  };

  const lockSeller = (userId) => {
    disableSeller(userId, cookies['access_token'])
  }

  const unlockSeller = (userId) => {
    enableSeller(userId, cookies['access_token'])
  }

  return (
    loading ? <LoadingScreen />
      :
      <div className={styles.table_wrapper}>
        {headers.map((header, index) => (
          <div key={index} className={styles.table_header}>{header}</div>
        ))}
        {sellers.length > 0 ? (
          sellers.map((row) => (
            editUserId === row.id ? (
              <>
                <input className={styles.table_cell} type="text" name="id" value={editedUser.id} onChange={handleChange} readOnly />
                <input className={styles.table_cell} type="text" name="name" value={editedUser.name} onChange={handleChange} />
                <input className={styles.table_cell} type="text" name="gender" value={editedUser.gender} onChange={handleChange} />
                <input className={styles.table_cell} type="email" name="email" value={editedUser.email} onChange={handleChange} />
                <input className={styles.table_cell} type="text" name="address" value={editedUser.address} onChange={handleChange} />
                <input className={styles.table_cell} type="text" name="city" value={editedUser.city} onChange={handleChange} />
                <input className={styles.table_cell} type="text" name="signup" value={editedUser.signup} onChange={handleChange} readOnly />
                <input className={styles.table_cell} type="text" name="lastLogin" value={editedUser.lastLogin} onChange={handleChange} readOnly />
                <div className={styles.table_cell}>
                  <button className={styles.iconButton1} onClick={handleSave}>{t('save')}</button>
                  <button className={styles.iconButton2} onClick={handleCancel}>{t('cancel')}</button>
                  <button className={styles.iconButton2} onClick={handleDelete}>{t('delete')}</button>
                </div>
              </>
            ) : (
              <>
                <div key={row.id} className={styles.table_row}>
                  <div className={styles.table_cell}>{row.id}</div>
                  <div className={styles.table_cell}>{row.name}</div>
                  <div className={styles.table_cell}>{row.gender}</div>
                  <div className={styles.table_cell}>{row.email}</div>
                  <div className={styles.table_cell}>{row.address}</div>
                  <div className={styles.table_cell}>{row.city}</div>
                  <div className={styles.table_cell}>{row.signup}</div>
                  <div className={styles.table_cell}>{row.lastLogin}</div>
                  <div className={styles.table_cell}>
                    <button className={styles.iconButton1} onClick={() => { handleEdit(row) }}>
                      <EditIcon titleAccess={t('edit')} />
                    </button>
                    {row.status ?
                      <button className={styles.iconButton2} onClick={() => { lockSeller(row.id) }}>
                        <LockIcon titleAccess={t('lock_account')} />
                      </button>
                      :
                      <button className={styles.iconButton2} onClick={() => { unlockSeller(row.id) }}>
                        <LockOpenIcon titleAccess={t('unlock_account')} />
                      </button>
                    }
                  </div>
                </div>
              </>
            )
          ))
        ) : (
          <div className={styles.no_data}>No data available</div>
        )}
      </div>
  );
}
